import React, { useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";


// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import { color } from "echarts";

const SidebarContent = props => {
	const ref = useRef();
	const user = JSON.parse(localStorage.getItem('authUser')).user;
	const roles = user.Roles.map(el => el.id);
	const partnerUser = roles.includes(4);
	const adminUser = roles.includes(2);
	const driverUser = roles.includes(3);
	const activateParentDropdown = useCallback((item) => {
		item.classList.add("active");
		const parent = item.parentElement;
		const parent2El = parent.childNodes[1];

		if (parent2El && parent2El.id !== "side-menu") {
			parent2El.classList.add("mm-show");
		}

		if (parent) {
			parent.classList.add("mm-active");
			const parent2 = parent.parentElement;

			if (parent2) {
				parent2.classList.add("mm-show"); // ul tag

				const parent3 = parent2.parentElement; // li tag

				if (parent3) {
					parent3.classList.add("mm-active"); // li
					parent3.childNodes[0].classList.add("mm-active"); //a
					const parent4 = parent3.parentElement; // ul
					if (parent4) {
						parent4.classList.add("mm-show"); // ul
						const parent5 = parent4.parentElement;
						if (parent5) {
							parent5.classList.add("mm-show"); // li
							parent5.childNodes[0].classList.add("mm-active"); // a tag
						}
					}
				}
			}
			scrollElement(item);
			return false;
		}
		scrollElement(item);
		return false;
	}, []);

	const removeActivation = (items) => {
		for (var i = 0; i < items.length; ++i) {
			var item = items[i];
			const parent = items[i].parentElement;

			if (item && item.classList.contains("active")) {
				item.classList.remove("active");
			}
			if (parent) {
				const parent2El =
					parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
						? parent.childNodes[1]
						: null;
				if (parent2El && parent2El.id !== "side-menu") {
					parent2El.classList.remove("mm-show");
				}

				parent.classList.remove("mm-active");
				const parent2 = parent.parentElement;

				if (parent2) {
					parent2.classList.remove("mm-show");

					const parent3 = parent2.parentElement;
					if (parent3) {
						parent3.classList.remove("mm-active"); // li
						parent3.childNodes[0].classList.remove("mm-active");

						const parent4 = parent3.parentElement; // ul
						if (parent4) {
							parent4.classList.remove("mm-show"); // ul
							const parent5 = parent4.parentElement;
							if (parent5) {
								parent5.classList.remove("mm-show"); // li
								parent5.childNodes[0].classList.remove("mm-active"); // a tag
							}
						}
					}
				}
			}
		}
	};

	const path = useLocation();
	const activeMenu = useCallback(() => {
		const pathName = path.pathname;
		let matchingMenuItem = null;
		const ul = document.getElementById("side-menu");
		const items = ul.getElementsByTagName("a");
		removeActivation(items);

		for (let i = 0; i < items.length; ++i) {
			if (pathName === items[i].pathname) {
				matchingMenuItem = items[i];
				break;
			}
		}
		if (matchingMenuItem) {
			activateParentDropdown(matchingMenuItem);
		}
	}, [path.pathname, activateParentDropdown]);

	useEffect(() => {
		ref.current.recalculate();
	}, []);

	useEffect(() => {
		new MetisMenu("#side-menu");
		activeMenu();
	}, []);

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
		activeMenu();
	}, [activeMenu]);

	function scrollElement(item) {
		if (item) {
			const currentPosition = item.offsetTop;
			if (currentPosition > window.innerHeight) {
				ref.current.getScrollElement().scrollTop = currentPosition - 300;
			}
		}
	}

	return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <div className="metismenu list-unstyled" id="side-menu">
            <h4 className="m-3">
              Welcome{" "}
              <span style={{ color: "orange" }}>
                {user.partner ? user.partner?.name : user.name}
              </span>
            </h4>
            {adminUser ? (
              <ul style={{ display: "block" }}>
                <li className="menu-title">{props.t("Menu")} </li>
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-home-circle"></i>
                    <span>{props.t("Dashboards")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/dashboard">{props.t("Dashboard")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="dripicons-user-group"></i>
                    <span>{props.t("Users")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/users">{props.t("List Users")}</Link>
                    </li>
                    <li>
                      <Link to="/users/add">{props.t("Add User")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="dripicons-user-group"></i>
                    <span>{props.t("Addresses")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/address">{props.t("List Addresses")}</Link>
                    </li>
                    <li>
                      <Link to="/address/add">{props.t("Add Address")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-globe"></i>
                    <span>{props.t("Countries")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/countries">{props.t("List Countries")}</Link>
                    </li>
                    <li>
                      <Link to="/countries/add">{props.t("Add Country")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-globe"></i>
                    <span>{props.t("Cities")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/cities">{props.t("List Cities")}</Link>
                    </li>
                    <li>
                      <Link to="/cities/add">{props.t("Add City")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-globe"></i>
                    <span>{props.t("Districts")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/districts">{props.t("List Districts")}</Link>
                    </li>
                    <li>
                      <Link to="/districts/add">{props.t("Add District")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-globe"></i>
                    <span>{props.t("Sub Districts")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/sub-districts">
                        {props.t("List Sub Districts")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/sub-districts/add">
                        {props.t("Add Sub District")}
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-globe"></i>
                    <span>{props.t("Languages")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/languages">{props.t("List Languages")}</Link>
                    </li>
                    <li>
                      <Link to="/languages/add">{props.t("Add language")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bxs-truck"></i>
                    <span>{props.t("Vehicles")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/vehicles">{props.t("List Vehicles")}</Link>
                    </li>
                    <li>
                      <Link to="/vehicles/add">{props.t("Add Vehicle")}</Link>
                    </li>
                    {/* <li>
                      <Link to="/vehicles/add-document">{props.t("Add Documents")}</Link>
                    </li>
                    <li>
                      <Link to="/vehicle-categories">{props.t("List Vehicle Categories")}</Link>
                    </li>
                    <li>
                      <Link to="/vehicle-categories/add">{props.t("Add Vehicle Category")}</Link>
                    </li> */}
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-list-ul"></i>
                    <span>{props.t("Shipment Types")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/shipment-types">
                        {props.t("List Shipment Types")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/shipment-types/add">
                        {props.t("Add Shipment Type")}
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-list-ul"></i>
                    <span>{props.t("Collection Hubs")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/collhub">
                        {props.t("List Collection Hubs")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/collhub/add">
                        {props.t("Add a collection hub")}
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-list-ul"></i>
                    <span>{props.t("Logs")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/collection-hub-logs">
                        {props.t("Collection Hub Logs")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/direct-delivery-logs">
                        {props.t("Direct Delivery Logs")}
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-user-circle"></i>
                    <span>{props.t("Drivers")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/drivers">{props.t("List Drivers")}</Link>
                    </li>
                    <li>
                      <Link to="/drivers/add">{props.t("Add Driver")}</Link>
                    </li>
                    <li>
                      <Link to="/drivers/add-document">
                        {props.t("Add Documents")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/drivers/assign-vehicle">
                        {props.t("Assign vehicle")}
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-user-circle"></i>
                    <span>{props.t("Driver Types")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/driver-type">
                        {props.t("List Driver Types")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/driver-type/add">
                        {props.t("Add Driver Type")}
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-user-circle"></i>
                    <span>{props.t("Partners")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/partners">{props.t("List Partners")}</Link>
                    </li>
                    <li>
                      <Link to="/partners/add">{props.t("Add Partner")}</Link>
                    </li>
                  </ul>
                </li>

                {/* <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-user-circle"></i>
                    <span>{props.t("Partners Time Slots")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/partnersbranch/timeslot">{props.t("List Partners Time Slots")}</Link>
                    </li>
                    <li>
                      <Link to="/partnersbranch/timeslot/add">{props.t("Add Partner Time Slot")}</Link>
                    </li>
                  </ul>
                </li> */}

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-briefcase-alt-2"></i>
                    <span>{props.t("Items")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/items">{props.t("List Items")}</Link>
                    </li>
                    <li>
                      <Link to="/items/add">{props.t("Add Item")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-briefcase-alt-2"></i>
                    <span>{props.t("Services")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/services">{props.t("List Services")}</Link>
                    </li>
                    <li>
                      <Link to="/services/add">{props.t("Add Service")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-briefcase-alt-2"></i>
                    <span>{props.t("Order Status")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/status">{props.t("List Status")}</Link>
                    </li>
                    <li>
                      <Link to="/status/add">{props.t("Add Status")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-list-ul"></i>
                    <span>{props.t("Screens")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/screens">{props.t("List Screens")}</Link>
                    </li>
                    <li>
                      <Link to="/screens/add">{props.t("Add Screen")}</Link>
                    </li>
                    <li>
                      <Link to="/sections">{props.t("Screen Sections")}</Link>
                    </li>
                    <li>
                      <Link to="/sections/add">
                        {props.t("Add Screen Section")}
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-list-ul"></i>
                    <span>{props.t("Delivery Types")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/delivery-types">
                        {props.t("List Delivery Types")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/delivery-types/add">
                        {props.t("Add Delivery Type")}
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-list-ul"></i>
                    <span>{props.t("Tasks")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/tasks">{props.t("List Tasks")}</Link>
                    </li>
                    <li>
                      <Link to="/tasks/add">{props.t("Add Task")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="dripicons-view-thumb"></i>
                    <span>{props.t("Management")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/roles">{props.t("Roles")}</Link>
                    </li>
                    <li>
                      <Link to="/application/setup">
                        {props.t("Application Setup")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/express-delivery-settings/settings">
                        {props.t("Express Delivery Settings")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/categories">{props.t("Categories")}</Link>
                    </li>
                    <li>
                      <Link to="/banners">{props.t("Banners")}</Link>
                    </li>
                    <li>
                      <Link to="/offers">{props.t("Offers")}</Link>
                    </li>
                    <li>
                      <Link to="/tickets">{props.t("Tickets")}</Link>
                    </li>
                    <li>
                      <Link to="/terms">{props.t("Terms & Conditions")}</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">
                        {props.t("Privacy Policy")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/faqs">{props.t("FAQs")}</Link>
                    </li>
                    <li>
                      <Link to="/payment-methods">
                        {props.t("Payment Methods")}
                      </Link>
                    </li>

                    <li>
                      <Link to="/#" className="has-arrow">
                        <i className="bx bx-globe"></i>
                        <span>{props.t("Reasons")}</span>
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link to="/reasons">{props.t("List Reasons")}</Link>
                        </li>
                        <li>
                          <Link to="/reasons/add">{props.t("Add Reason")}</Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            ) : (
              <></>
            )}
            {adminUser&&(
              <ul style={{ display: "block" }}>
              <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-briefcase-alt-2"></i>
                    <span>{props.t("Driver Emergency")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/driver-emergencies">
                        {props.t("Driver Emergency Details")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/#" className="has-arrow">
                        <i className="bx bx-briefcase-alt-2"></i>
                        <span>{props.t("Emergency Types")}</span>
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link to="/emergency-types">
                            {props.t("Emergency Types")}
                          </Link>
                        </li>
                        <li>
                          <Link to="/emergency-types/add">
                            {props.t("Add Emergency Type")}
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <Link to="/#" className="has-arrow">
                        <i className="bx bx-briefcase-alt-2"></i>
                        <span>{props.t("Emergency Sub Types")}</span>
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link to="/emergency-sub-types">
                            {props.t("Emergency Sub Types")}
                          </Link>
                        </li>
                        <li>
                          <Link to="/emergency-sub-types/add">
                            {props.t("Add Emergency Sub Type")}
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            )}
            {partnerUser || adminUser ? (
              <ul style={{ display: "block" }}>
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-user-circle"></i>
                    <span>{props.t("Partners Branch")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/partnersbranch">
                        {props.t("List Partners Branch")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/partnersbranch/add">
                        {props.t("Add Partner Branch")}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-user-circle"></i>
                    <span>{props.t("Time Slots")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/timeslots">{props.t("List Time Slots")}</Link>
                    </li>
                    <li>
                      <Link to="/timeslots/add">
                        {props.t("Add Time Slot")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/timeslots/exceptions/add">
                        {props.t("Add Time Slot Exception")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/timeslots/exceptions">
                        {props.t("List Time Slot Exception")}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-briefcase-alt-2"></i>
                    <span>{props.t("Payment Status")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/payment-statuses">
                        {props.t("List Payment Status")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/payment-statuses/add">
                        {props.t("Add Payment Status")}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-briefcase-alt-2"></i>
                    <span>{props.t("Orders")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/orders">{props.t("List Orders")}</Link>
                    </li>
                    <li>
                      <Link to="/orders/add">{props.t("Add Order")}</Link>
                    </li>
                  </ul>
                </li>
              </ul>
            ) : (
              <></>
            )}
            <ul style={{ display: "block" }}>
              <li>
                <Link to="/logout">
                  <i className="dripicons-power" />
                  <span>{props.t("Logout")}</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
};

SidebarContent.propTypes = {
	location: PropTypes.object,
	t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
